import styled from 'styled-components';

const SingleMentorCardStyled = styled.div`
  display: grid;
  grid-gap: 1.2rem;
  grid-template-columns: repeat(auto-fill, minmax(min-content, 350px));
  justify-content: center;
  align-items: center;
`;

export default SingleMentorCardStyled;
